module.exports = __webpack_public_path__ + "static/img/solutions3.5eefcc18.png";